import React, {useState, useEffect, Suspense} from 'react';
import ReactDOM from "react-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Home() {
    const [isLoaded, setIsLoaded] = useState(false);
    const [ticks, setTicks] = useState(0);
    const theme = document.documentElement.getAttribute('data-bs-theme') || 'light';
    const language = document.getElementById('language');

    let user = null;
    const userDataElem = document.getElementById('user-data');
    if (userDataElem && userDataElem.textContent) {
        user = JSON.parse(userDataElem.textContent);
    }
    window.user = user;
    const [loggedinuser] = useState(user);
    const accountingUrl = language
        ? `${window.location.origin}/acc?theme=${theme}&lang=${language.value}`
        : `${window.location.origin}/acc?theme=${theme}`;

    useEffect(() => {
        const interval = setInterval(() => {
            setTicks(prevTicks => prevTicks + 1);
            setIsLoaded(true);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="container mt-5">
            {isLoaded ? (
                loggedinuser ? (
                    <div>
                        <div className="row">
                            <div className="col text-center">
                                <h1 className="display-4">{loggedinuser?.company?.name}</h1>
                            </div>
                        </div>
                        <h1 className="mb-4">Hello {loggedinuser.username}</h1>
                        <div className="row g-4">
                            <div className="col-md-4">
                                <div className="card border-info h-100">
                                    <div className="card-body text-center">
                                        <h2 className="card-title">Let's</h2>
                                        <p className="card-text">
                                            An invitation to participate in a collaborative effort and sharing responsibility with a unified Goal
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card border-info h-100">
                                    <div className="card-body text-center">
                                        <h2 className="card-title">Keep</h2>
                                        <p className="card-text">
                                            Maintain, monitor and manage timeously
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card border-info h-100">
                                    <div className="card-body text-center">
                                        <h2 className="card-title">Book</h2>
                                        <p className="card-text">
                                            Consultants, customers, resources and deliverables
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <button
                                className="btn btn-primary btn-lg mt-4"
                                onClick={() => window.location.href = accountingUrl}
                            >Proceed to Accounting
                            </button>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="py-5 text-center bg-light rounded shadow">
                            <h1 className="display-4 mb-3">Welcome to Let's Keep Book</h1>
                            <p className="lead mb-4">
                                Organize, collaborate, and manage your bookings with ease.<br/>
                                Join us today to get started!
                            </p>
                            <div className="d-flex justify-content-center gap-3">
                                <a href="/login" className="btn btn-info btn-lg px-4">Login</a>
                                <a href="/signup" className="btn btn-outline-info btn-lg px-4">Sign Up</a>
                            </div>
                        </div>
                        <div className="row g-4 mt-5">
                            <div className="col-md-4">
                                <div className="card shadow-lg h-100">
                                    <div className="card-body text-center">
                                        <h2 className="card-title">Let's</h2>
                                        <p className="card-text">
                                            An invitation to participate in a collaborative effort and sharing responsibility with a unified Goal
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card shadow-lg h-100">
                                    <div className="card-body text-center">
                                        <h2 className="card-title">Keep</h2>
                                        <p className="card-text">
                                            Maintain, monitor and manage timeously
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card shadow-lg h-100">
                                    <div className="card-body text-center">
                                        <h2 className="card-title">Book</h2>
                                        <p className="card-text">
                                            Consultants, customers, resources and deliverables
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )
            ) : (
                <div>
                </div>
            )}
        </div>
    );
}

const rootElement = document.getElementById('home');
if (rootElement) {
    ReactDOM.render(<Suspense fallback={<div>Loading...</div>}><Home/></Suspense>, rootElement);
} else {
    console.error('Root element not found');
}